export default "__VITE_ASSET__DLNww72P__"